
import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "app/data/common/queryKeys";
import AddressmanagerService from "app/data/address-manager/addressService";

export const useVerified = (selectedAddressId: string) => {
  const { data: verifiedDetails, isLoading: isLoadingVerifiedDetails, refetch: refetchVerifiedDetails } = useQuery({
    queryKey: [QUERY_KEYS.VERIFIED_DETAILS, selectedAddressId],
    queryFn: async () => {
      if (!selectedAddressId) return;
      return await AddressmanagerService.getInstance().getVerifiedDetails(selectedAddressId);
    },
    enabled: !!selectedAddressId,
    refetchOnWindowFocus: false,
  })

  return {
    data: verifiedDetails,
    isLoading: isLoadingVerifiedDetails,
    refetch: refetchVerifiedDetails,
  }
}